import { render, staticRenderFns } from "./Cupones-cartera.vue?vue&type=template&id=73bb7987&scoped=true"
import script from "./Cupones-cartera.vue?vue&type=script&lang=js"
export * from "./Cupones-cartera.vue?vue&type=script&lang=js"
import style0 from "./Cupones-cartera.vue?vue&type=style&index=0&id=73bb7987&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bb7987",
  null
  
)

export default component.exports